module.exports = __webpack_public_path__ + "static/media/toyota-vial.4a84bb59.svg";